export default __webpack_public_path__ + "static/media/conqueror_color.46b293b5.png";